export const MULTICOLOR =
  "linear-gradient(225deg, #bc32ed 0%, #bc32ed 26.04%, #74dc7f 42.19%, #76db80 60.94%, #ff4d4d 76.04%, #ff5050 100%)";

export const COLORS_OPTIONS = [
  {
    label: "Almond",
    value: "Almond",
    color: "#EFDECD"
  },
  {
    label: "Amber",
    value: "Amber",
    color: "#FFBF00"
  },
  {
    label: "Anthracite",
    value: "Anthracite",
    color: "#2F4F4F"
  },
  {
    label: "Silver",
    value: "Silver",
    color: "#C0C0C0"
  },
  {
    label: "Eggplant",
    value: "Eggplant",
    color: "#3B0910"
  },
  {
    label: "Beige",
    value: "Beige",
    color: "#F5F5DC"
  },
  {
    label: "White",
    value: "White",
    color: "#FFFFFF"
  },
  {
    label: "Off-white",
    value: "Off-white",
    color: "#FFFFFF"
  },
  {
    label: "Blue",
    value: "Blue",
    color: "#0000FF"
  },
  {
    label: "Sky blue",
    value: "Sky blue",
    color: "#87CEEB"
  },
  {
    label: "Electric blue",
    value: "Electric blue",
    color: "#7DF9FF"
  },
  {
    label: "Glacier blue",
    value: "Glacier blue",
    color: "4B9CD3"
  },
  {
    label: "Navy blue",
    value: "Navy blue",
    color: "#000080"
  },
  {
    label: "Rosewood",
    value: "Rosewood",
    color: "#B76E79"
  },
  {
    label: "Burgundy",
    value: "Burgundy",
    color: "#800000"
  },
  {
    label: "Bronze",
    value: "Bronze",
    color: "#CD7F32"
  },
  {
    label: "Brick",
    value: "Brick",
    color: "#bc4a3c"
  },
  {
    label: "Celadon",
    value: "Celadon",
    color: "#ACE1AF"
  },
  {
    label: "Cherry",
    value: "Cherry",
    color: "#DE3163"
  },
  {
    label: "Chocolate",
    value: "Chocolate",
    color: "#D2691E"
  },
  {
    label: "Lemon",
    value: "Lemon",
    color: "#FFFACD"
  },
  {
    label: "Coral",
    value: "Coral",
    color: "#FF7F50"
  },
  {
    label: "Crimson",
    value: "Crimson",
    color: "#DC143C"
  },
  {
    label: "Cream",
    value: "Cream",
    color: "#FFFDD0"
  },
  {
    label: "Copper",
    value: "Copper",
    color: "#B87333"
  },
  {
    label: "Cyan",
    value: "Cyan",
    color: "#00FFFF"
  },
  {
    label: "Emerald",
    value: "Emerald",
    color: "#50C878"
  },
  {
    label: "Raspberry",
    value: "Raspberry",
    color: "#E30B5D"
  },
  {
    label: "Fuchsia",
    value: "Fuchsia",
    color: "#FF00FF"
  },
  {
    label: "Smoke",
    value: "Smoke",
    color: "#605F5E"
  },
  {
    label: "Garnet",
    value: "Garnet",
    color: "#733635"
  },
  {
    label: "Gray",
    value: "Gray",
    color: "#808080"
  },
  {
    label: "Indigo",
    value: "Indigo",
    color: "#4B0082"
  },
  {
    label: "Ivory",
    value: "Ivory",
    color: "#FFFFF0"
  },
  {
    label: "Yellow",
    value: "Yellow",
    color: "#FFFF00"
  },
  {
    label: "Mustard yellow",
    value: "Mustard yellow",
    color: "#FFDB58"
  },
  {
    label: "Khaki",
    value: "Khaki",
    color: "#F0E68C"
  },
  {
    label: "Lavender",
    value: "Lavender",
    color: "#E6E6FA"
  },
  {
    label: "Magenta",
    value: "Magenta",
    color: "#FF00FF"
  },
  {
    label: "Brown",
    value: "Brown",
    color: "#A52A2A"
  },
  {
    label: "Mint",
    value: "Mint",
    color: "#98FF98"
  },
  {
    label: "Mustard",
    value: "Mustard",
    color: "#FFDB58"
  },
  {
    label: "Black",
    value: "Black",
    color: "#000000"
  },
  {
    label: "Olive",
    value: "Olive",
    color: "#808000"
  },
  {
    label: "Gold",
    value: "Gold",
    color: "#FFD700"
  },
  {
    label: "Orange",
    value: "Orange",
    color: "#FFA500"
  },
  {
    label: "Peach",
    value: "Peach",
    color: "#FFDAB9"
  },
  {
    label: "Petrol",
    value: "Petrol",
    color: "#006B6B"
  },
  {
    label: "Pistachio",
    value: "Pistachio",
    color: "#93C572"
  },
  {
    label: "Powder",
    value: "Powder",
    color: "#E3D6CF"
  },
  {
    label: "Plum",
    value: "Plum",
    color: "#8E4585"
  },
  {
    label: "Pink",
    value: "Pink",
    color: "#FFC0CB"
  },
  {
    label: "Candy pink",
    value: "Candy pink",
    color: "#FF69B4"
  },
  {
    label: "Red",
    value: "Red",
    color: "#FF0000"
  },
  {
    label: "Bright red",
    value: "Bright red",
    color: "#FF2400"
  },
  {
    label: "Sand",
    value: "Sand",
    color: "#F4A460"
  },
  {
    label: "Sapphire",
    value: "Sapphire",
    color: "#0F52BA"
  },
  {
    label: "Salmon",
    value: "Salmon",
    color: "#FA8072"
  },
  {
    label: "Tobacco",
    value: "Tobacco",
    color: "#D2B48C"
  },
  {
    label: "Taupe",
    value: "Taupe",
    color: "#483C32"
  },
  {
    label: "Tomato",
    value: "Tomato",
    color: "#FF6347"
  },
  {
    label: "Turquoise",
    value: "Turquoise",
    color: "#40E0D0"
  },
  {
    label: "Vermilion",
    value: "Vermilion",
    color: "#E34234"
  },
  {
    label: "Green",
    value: "Green",
    color: "#008000"
  },
  {
    label: "Anise green",
    value: "Anise green",
    color: "#7FFF00"
  },
  {
    label: "Violet",
    value: "Violet",
    color: "#800080"
  },
  {
    label: "Multi",
    value: "Multi",
    color: MULTICOLOR
  },
  {
    label: "No colors",
    value: "No colors"
  }
];

export const SIZES_OPTIONS = [
  { value: "XXXS", label: "XXXS" },
  { value: "XXS", label: "XXS" },
  { value: "XS", label: "XS" },
  { value: "S", label: "S" },
  { value: "M", label: "M" },
  { value: "L", label: "L" },
  { value: "XL", label: "XL" },
  { value: "XXL", label: "XXL" },
  { value: "XXXL", label: "XXXL" },
  { value: "XXXXL", label: "XXXXL" },
  { value: "NO SIZES", label: "NO SIZES" }
];
